/* @flow */
import React from 'react';
import { Link } from 'react-router';
import Translate from 'react-translate-component';
import Cross from '../svg/cross';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import CookieUtils from 'frilans-finans/utils/cookie-utils';

export class InfoBanner extends React.Component {

  constructor () {
    super();

    this.state = {
      showInfoBanner: false
    };

    this.closeInfoBanner = this.closeInfoBanner.bind(this);
  }

  componentDidMount () {
    let text = proxyCounterpart('INFO_BANNER_TEXT', { fallback: 'notransfound' });

    if (text !== 'notransfound' && !CookieUtils.getInfoBannerClosed(text)) {
      this.setState({
        showInfoBanner: true
      });
    }
  }

  closeInfoBanner () {
    const text = proxyCounterpart('INFO_BANNER_TEXT');
    CookieUtils.setInfoBannerClosed(text);
    this.setState({
      showInfoBanner: false
    });
  }

  render () {
    return (<div className={'info-banner-wrapper' + (this.state.showInfoBanner ? '' : ' hidden')}>
      <img className='info-banner-image' src={proxyCounterpart('INFO_BANNER_IMAGE')} />
      <Translate className='info-banner-text' content='INFO_BANNER_TEXT' />
      <div className='info-banner-action-container'>
        <Link
          to={proxyCounterpart('INFO_BANNER_READ_MORE_LINK')}
          target="_blank"
          className='info-banner-link'
        >
          <Translate content='INFO_BANNER_READ_MORE_BUTTON' />
        </Link>
        <div onClick={this.closeInfoBanner} className='info-banner-close'>
          <Cross colorSchema='primary' />
        </div>
      </div>
    </div>);
  }
}

export default InfoBanner;



/** WEBPACK FOOTER **
 ** ./src/components/info-banner/info-banner.js
 **/